import React, { useEffect, useState } from 'react';

/*
 * Live-updating UTC clock shown in dashboard headers, since every Airflow timestamp is UTC
 */
export function UtcClock() {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const interval = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(interval);
    }, []);

    const pad = (n: number) => String(n).padStart(2, '0');
    return <span>{`${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(now.getUTCSeconds())} UTC`}</span>;
}
